
import { Component, Vue, Watch } from "vue-property-decorator";
import FormBase from "@/lib/view-base/formbase";
import { CreateProductDto, ProductService, ProductCategoryService, UpdateProductMoreFileDto, CreateOrUpdateProductSpecificationDto } from "@/api/service-proxies";
import SelectTree from "@/components/SelectTree/SelectTree.vue";
import WangEditor from 'wangeditor'
import appconst from "@/lib/appconst";
import imgOrVideo from "@/components/uploader/imgAndVideo.vue"
import ImageUploader from '@/components/uploader/imageUploader.vue'
import PreViewDialog from "../components/previewDialog.vue";

@Component({
    name: "CreateProduct",
    components: {
        SelectTree, imgOrVideo, ImageUploader, PreViewDialog
    },
})
export default class CreateProduct extends FormBase {
    product = new CreateProductDto({
        imageList: [],
        specificationList: [],
        isFree:false,
        isShow:false,
        readCount:0,
        integral:0,
        isStartGroupBuying:false,
        groupBuyingAmount:0,
        isShowHot :false,
        isShowEndTimeAndDiscount:false

    });
    productService: ProductService = new ProductService();
    //商品分类
    productCategoryService: ProductCategoryService = new ProductCategoryService();
    productCategoryType: any = [];
    rules: object = {
        name: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        productCategoryId: [
            { required: true, message: "请选择商品类型", trigger: "blur" },
        ],

        price: [
            { required: true, message: "请输入商品价格", trigger: "blur" },
        ],
        // integral: [
        //     { required: true, message: "请输入赠送积分", trigger: "blur" },
        // ],
        // IsFree: [
        //     { required: true, message: "是否包邮", trigger: "blur" },
        // ],

        introduction: [],
        isRegisterd: [],
        organizationUnitId: [],
    };
    defaultProps = {
        parent: "parentId", // 父级唯一标识
        value: "id", // 唯一标识
        label: "displayName", // 标签显示
        children: "children",
    };
    IsFree = 1
    options = [];
    tableData: []
    buttonlist: any = [
        { id: 1, name: '7天无理由退货', type: 'success' },
        { id: 2, name: '赠品保障', type: 'danger' },
        { id: 3, name: '破损包退换', type: 'danger' },
        { id: 4, name: '店铺发货%售后', type: 'danger' },
        { id: 5, name: '免运费', type: 'danger' }
    ]
    imageUploadAction = appconst.remoteServiceBaseUrl + 'sysadmin/UploadFile/ProductUpload'
    inputValue2: any = '' // 正文内容  textarea框值
    productImg = ''
    mounted() {
        this.initEditor();
        this.initProductCategory();
        this.initServer();
    }

    created() { }
    async submitExecute(): Promise<void> {
        this.product.state = 1;
        this.product.isShow = false;
        this.product.describe = this.inputValue2;
        this.product.salesType = "";
        //console.info(this.buttonlist);
        //服务列表选中状态
        var salesTypeID = this.buttonlist.filter(item => item.isSelect).map(item => item.id);

        this.product.salesType = JSON.stringify(salesTypeID).replace("[", "").replace("]", "");
        this.product.p_Path = (this as any).$aes.imgDelAuth(this.product.p_Path)
        this.product.imageList.forEach(e=>{
            e.p_Path = (this as any).$aes.imgDelAuth(e.p_Path)
          })
        await this.productService.create(this.product);
    }
    handleSuccess(response, file, fileList) {
        this.product.p_Path = response.result.url

    }
    handleFaceUpladSuccess(url) {
        this.product.p_Path = (this as any).$aes.imgAddAuth(url)
        // this.$set(this.model, 'coverImageUrl', url)
    }
    // 图片返回数据
    handleImageORVideoSuccess(url) {
        var isImg = "video";
        if (
            url.type.slice(0, 6) == "image/" ||
            url.type.slice(0, 6) == "video/"
        ) {
            if (url.type.slice(0, 6) == "image/") {
                isImg = "png";
            }
            var obj = {
                url: url.url,
                isImg: isImg,

            }
            this.product.imageList.push(new UpdateProductMoreFileDto({
                p_Path: (this as any).$aes.imgAddAuth(url.url),
                attachmentType: isImg,
                id: 0

            }));
            console.log(this.product.imageList)
        }
        // this.product.imageList.push(url)
    }
    handleimageSuccess(url) {
        this.product.p_Path = url
    }
    // 打开预览弹框
    openDialog(index) {
        (this.$refs.preViewDialogRef as PreViewDialog).open(this.product.imageList,
            index
        );
    }
    // 删除已选图片或视频
    delImgOrVideo(index) {
        this.product.imageList.splice(index, 1);
    }
    private initEditor() {
        let editor = new WangEditor('#editor')
        editor.config.menus = [
            'head',
            'bold',
            'fontSize',
            'italic',
            'underline',
            'strikeThrough',
            'indent',
            'lineHeight',
            'foreColor',
            'backColor',
            'list',
            'justify',
            'quote',
            'emoticon',
            'image',
            //'video',
            'splitLine',
            'undo',
            'redo',
        ]
        editor.config.zIndex = 20
        editor.config.uploadImgServer = this.imageUploadAction
        editor.config.uploadFileName = 'file'
        editor.config.uploadImgHooks = {
            customInsert: (insertImgFn: any, response: any) => {
                editor.cmd.do(
                    'insertHTML',
                    `<img src="${(this as any).$aes.imgAddAuth(response.result.url)}" style="max-width:100%;" contenteditable="false"/>`
                )
            },
        }
        editor.config.uploadVideoServer = this.imageUploadAction
        editor.config.uploadVideoName = 'file'
        editor.config.uploadVideoMaxSize = 1 * 1024 * 1024 * 100 // 100M
        editor.config.uploadVideoAccept = ['mp4']
        editor.config.uploadVideoHooks = {
            before: (xhr) => {
                if (this.inputValue2) {
                    let div = document.createElement('div')
                    div.innerHTML = this.inputValue2
                    if (div.querySelectorAll('video').length >= 3) {
                        return {
                            prevent: true,
                            msg: '最多只能上传3个视频',
                        }
                    }
                }
            },
            customInsert: (insertVideoFn: any, response: any) => {
                editor.cmd.do(
                    'insertHTML',
                    `<p><video poster="${(this as any).$aes.imgAddAuth(response.result.url)}" controls="controls" style="max-width:100%"><source src="${(this as any).$aes.imgAddAuth(response.result.url)}" type="video/mp4" /></video></p><p>&#8203</p>`
                )
            },
        }
        editor.config.onchange = (html) => {
            this.inputValue2 = html
        }
        editor.create()
        editor.txt.html(this.inputValue2)
    }


    //获取商品分类的数据
    initProductCategory() {
        var _that = this;
        this.productCategoryService.getAllProductCategory().then(res => {
            _that.productCategoryType = res;
        });


    }

    handleMoreSuccess(response: any, file: any, fileList) {
        console.info("文件类型" + JSON.stringify(file));
        // 假设上传成功后服务器返回的图片URL在response.url中
        this.product.imageList.push(new UpdateProductMoreFileDto({
            p_Path: response.result.url,
            attachmentType: file.name,
            id: 0
        }));

    }
    handleRemove(file, fileList) {
        // 移除图片时更新列表
        this.product.imageList = this.product.imageList.filter(img => img.attachmentType !== file.attachmentType);
    }


    //增加规格
    handleAddExperienceline() {

        if (this.product.specificationList == undefined) {
            this.product.specificationList = new Array();
        }
        let obj = new CreateOrUpdateProductSpecificationDto({
            id: 0,
            /** 规格名称 */
            specName: "",
            /** 赠送积分 */
            integral: 0,
            /** 库存 */
            inventoryNum: 999,
            /** 折扣前价格 */
            beforePrice: 0,
            /** 折扣后价格 */
            afterPrice: 0,
            /** 是否选中 */
            isSelect: false,
        });
        this.product.specificationList.push(obj);
    }

    //保存单行数据
    async handlesaveExperience(index, rowData) {


    }
    handleDeleteExperience(index, rowData) {

        this.product.specificationList = this.product.specificationList.filter((element, i) => i !== index);
    }

    initServer() {
        this.productService.getSalesServiceTypeList().then((result) => {

            this.buttonlist = result;
        });
    }

    toggleSelection(index) {
        this.buttonlist.forEach((button, i) => {
            this.$set(this.buttonlist[i], 'isSelected', i === index);
        });
    }

    statusSwitchChange(isFree) {

        this.product.isFree = isFree;

    }
}
